<app-parking-hero></app-parking-hero>
<app-parking-challanges
  section
  sectionId="parking-challenges"
  i18n-sectionLabel="@@autpark.challenges.label"
  sectionLabel="Wyzwania"
  [sectionListable]="true">
</app-parking-challanges>
<app-parking-location
  section
  sectionId="parking-locations"
  i18n-sectionLabel="@@autpark.locations.label"
  sectionLabel="Lokalizacja"
  [sectionListable]="true">
</app-parking-location>
<app-parking-offer
  section
  sectionId="parking-offer"
  i18n-sectionLabel="@@autpark.offer.label"
  sectionLabel="Oferta"
  [sectionListable]="true">
</app-parking-offer>
<app-parking-about></app-parking-about>
<app-parking-logistics
  section
  sectionId="parking-logistics"
  i18n-sectionLabel="@@autpark.logistics.label"
  sectionLabel="Logistyka"
  [sectionListable]="true">
</app-parking-logistics>
<app-parking-steps></app-parking-steps>
<app-parking-form
  section
  sectionId="application-form"
  i18n-sectionLabel="@@autpark.form.label"
  sectionLabel="Kontakt"
  [sectionListable]="true">
</app-parking-form>
<app-footer></app-footer>


